var cartItems = [];
var productsId = [];

$.get("cart.json", function(data, status){
  cartItems = data.items;
  productsId = cartItems.map(obj => obj.id);

  cartItems.map((data, index) => {
    if(data.product_type == 'SETUP_COST'){
      $(`.order-summary__body tr:nth-child(${index+1})`).find('.quantity-input').prop("disabled", true);
      $(`.order-summary__body tr:nth-child(${index+1})`).find('.quantity-input').siblings('.text-xs').remove();
    }
  })

  let reloadNeeded = false;
  cartItems.map((data) => {
    if(data.product_type == 'SETUP_COST'){
      if(productsId.length){
        if(!productsId.includes(parseFloat(data.properties.pc_ref))){
          reloadNeeded = true;
          $.ajax({
            type: "POST",
            url: '/cart/change.js',
            async: false,
            data: {id: data.id, quantity: 0},
            success: function(){
            },
            dataType: "json"
          });
        }else if(data.quantity > 1){
          reloadNeeded = true;
          $.ajax({
            type: "POST",
            url: '/cart/change.js',
            async: false,
            data: {id: data.id, quantity: 1},
            success: function(){
              // location.reload();
            },
            dataType: "json"
          });
        }
      }
    }
  })
  if(reloadNeeded) {
    location.reload();
  }
  
});
